import { ctaDesc, ctaTitle } from "@/lib/seo";
import { createFileRoute, notFound } from "@tanstack/react-router";
import NotaryProductPage from "@/components/NotaryProductPage";
import { getNotaryProduct, NOTARY_PRODUCTS } from "@/data/notary-products";
import { notaryProductGraph, defaultNotaryProductFaqs } from "@/lib/notary-product-schema";
import { BRAND_URL } from "@/lib/brand";

export const Route = createFileRoute("/notary/products/$slug")({
  loader: ({ params }) => {
    const p = getNotaryProduct(params.slug);
    if (!p) throw notFound();
    return { product: p };
  },
  head: ({ loaderData, params }) => {
    if (!loaderData) return { meta: [{ title: ctaTitle("Notary — ไม่พบบริการ", "/notary/products/$slug", "th")}, { name: "robots", content: "noindex" }] };
    const p = loaderData.product;
    const path = `/notary/products/${params.slug}`;
    const url = `${BRAND_URL}${path}`;
    const title = `${p.nameTh} โดยทนาย Notary Public | ${p.act.turnaround}`;
    const desc = p.shortDescTh + " · ทนายผู้รับรองเอกสารจดทะเบียนสภาทนายความไทย — ใช้ยื่น MFA / Apostille / สถานทูตได้ทันที";
    const faqs = defaultNotaryProductFaqs(p, "th");
    return {
      meta: [
        { title: ctaTitle(title, "/notary/products/$slug", "th") }, { name: "description", content: ctaDesc(desc, "/notary/products/$slug", "th")},
        { property: "og:title", content: ctaTitle(title, "/notary/products/$slug", "th")},
        { property: "og:description", content: ctaDesc(desc, "/notary/products/$slug", "th")},
        { property: "og:url", content: url },
        { property: "og:type", content: "product" },
        { property: "og:locale", content: "th_TH" },
        { property: "product:price:amount", content: String(p.priceMid) },
        { property: "product:price:currency", content: "THB" },
      ],
      links: [
        { rel: "canonical", href: url },
        { rel: "alternate", hrefLang: "th-TH", href: url },
        { rel: "alternate", hrefLang: "en", href: `${BRAND_URL}/en/notary/products/${params.slug}` },
        { rel: "alternate", hrefLang: "x-default", href: url },
      ],
      scripts: [{
        type: "application/ld+json",
        children: JSON.stringify(notaryProductGraph({ product: p, locale: "th", path, faqs })),
      }],
    };
  },
  notFoundComponent: () => <div className="p-16 text-center">ไม่พบบริการที่ค้นหา</div>,
  component: () => {
    const { product } = Route.useLoaderData();
    return <NotaryProductPage product={product} locale="th" faqs={defaultNotaryProductFaqs(product, "th")} />;
  },
});

export const NOTARY_PRODUCT_SLUGS = NOTARY_PRODUCTS.map((p) => p.slug);
